import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { getVendorData } from "../../AddDetails/Vendor/Vendor.action";
import { ReceivingReportApi } from "./ProductionReceivingAction";
import { GetOrderCreationApi } from "../orderCreation/OrderCreationAction";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import MaterialSize from "material-table";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import moment from "moment";
import jsPDF from "jspdf";


const ReceivingReport = (props) => {
    const [vendorId, setVendorId] = useState();
    const [vendorName, setVendorName] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [orderId, setOrderId] = useState();
    const [orderSeqId, setOrderSeqId] = useState();
    const [show, setShow] = useState(false);

    const handleChangeVendor = (selectedOption) => {
        setVendorId(selectedOption.value);
        setVendorName(selectedOption.label);
    };
    const GetVendorList = !_.isEmpty(props.vendorDataList) && props.vendorDataList.map((x) => {
        let data = { value: x._id, label: x.vendorName };
        return data;
    });

    const handleChangeOrder = (selectedOption) => {
        setOrderId(selectedOption.value);
        setOrderSeqId(selectedOption.label)
    };
    const GetOrderList = !_.isEmpty(props.orderCreationList) && props.orderCreationList.map((x) => {
        let data = { value: x._id, label: `${x.sequenceNumber}` };
        return data;
    });

    useEffect(() => {
        props.getVendorData();
        props.GetOrderCreationApi();
        props.setHeading("Receiving Report");
    }, []);

    function SearchData() {
        props.ReceivingReportApi({
            vendorId: vendorId,
            orderId: orderId,
            startDate: startDate,
            endDate: endDate,
        });
        setShow(true);
    }

    return (
        <>
            {props.isFetchingVendor || props.isFetchingOrderCreation ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select Order </b></Form.Label>
                                <Select
                                    isDisabled={_.isEmpty(GetOrderList)}
                                    placeholder="Select Order"
                                    onChange={handleChangeOrder}
                                    options={GetOrderList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label><b>Start Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="Start Date"
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label><b>End Date</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    placeholder="End Date"
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" >
                                <Form.Label><b>Select Vendor</b></Form.Label>
                                <Select
                                    placeholder="Select Vendor"
                                    onChange={handleChangeVendor}
                                    options={GetVendorList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SearchData}> SEARCH </Button>
                    </div>


                    <div>
                        {show &&
                            <MaterialSize
                                title="Receving Report"
                                columns={[
                                    { title: 'Order No#', field: 'orderNumber' },
                                    { title: 'Receiving No#', field: 'sequenceNumber' },
                                    // issuance id
                                    { title: 'Vendor Name', field: 'vendorName' },
                                    { title: 'Article Name', field: 'articleName' },
                                    // processName,
                                    // issuance date
                                    // return date
                                    { title: 'Receiving Date', field: 'issuanceDate' },
                                    { title: 'Issuance Quantity', field: 'issueQuantity' },
                                    { title: 'Receiving Quantity', field: 'recevingQuantity' },
                                    // processRate
                                    { title: 'Pending Quantity', field: 'pendingQuantity' },
                                    // total
                                ]}
                                data={props.productionReceivingReport.data}
                                options={{
                                    // actionsColumnIndex: -1,
                                    exportButton: true,
                                    exportAllData: true,
                                    paging: true,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        onRowAdd: "none",
                                    },
                                    exportPdf: (columns, data) => {
                                        const orientation = "landscape";
                                        const doc = new jsPDF(orientation);

                                        const columnTitles = [
                                            "Order No",
                                            "Issuance No",
                                            "Vendor Name",
                                            "Receiving Date",
                                            "Article Name",
                                            "Issuance Quantity",
                                            "Receiving Quantity",
                                            "Pending Quantity",
                                        ];

                                        const pdfData = data.map((rowData) => [
                                            rowData.orderNumber,
                                            rowData.sequenceNumber,
                                            rowData.vendorName,
                                            rowData.issuanceDate,
                                            rowData.articleName,
                                            rowData.issueQuantity,
                                            rowData.recevingQuantity,
                                            rowData.pendingQuantity,
                                        ]);

                                        let content = {
                                            startY: 70,
                                            startX: 10,
                                            head: [columnTitles],
                                            body: pdfData,
                                            styles: { fontSize: 10 },
                                            headStyles: { fillColor: "#2980ba" },
                                            footStyles: { fontStyle: "bold" }
                                        };

                                        // doc.addImage(logo, "PNG", 15, 9, 28, 28);
                                        doc.setFontSize(12);
                                        doc.setFont("times", "normal");
                                        doc.setFont(undefined, "bold");
                                        doc.text(process.env.REACT_APP_COMPANY_NAME, 50, 18);
                                        doc.setFont("times", "normal");
                                        doc.text(process.env.REACT_APP_COMPANY_ADDRESS, 50, 25);
                                        doc.text(process.env.REACT_APP_COMPANY_NTN, 50, 32);
                                        doc.text(`Receiving Report`, 90, 40);
                                        doc.text(`Order Number: ${_.isUndefined(orderSeqId) ? '' : orderSeqId}`, 15, 50);
                                        doc.text(`Start Date: ${_.isUndefined(startDate) ? '' : startDate}`, 15, 55);
                                        doc.text(`End Date: ${_.isUndefined(endDate) ? '' : endDate}`, 15, 60);
                                        doc.text(`Vendor Name: ${_.isUndefined(vendorName) ? '' : vendorName}`, 15, 65);

                                        doc.autoTable(content);

                                        doc.setProperties({ title: `Receiving Report ${moment().format('YYYY-MM-DD')}` });

                                        var blob = doc.output("blob");
                                        window.open(URL.createObjectURL(blob));
                                    }
                                }}
                            />
                        }
                    </div>

                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        ReceivingReportApi: (data) => dispatch(ReceivingReportApi(data)),
        getVendorData: () => dispatch(getVendorData()),
        setHeading: (data) => dispatch(setHeading(data)),
        GetOrderCreationApi: () => dispatch(GetOrderCreationApi()),
    };
};

const mapStateToProps = (state, ownProps) => ({
    vendorDataList: state.VendorReducer.vendorDataList,
    isFetchingVendor: state.VendorReducer.isFetchingVendor,
    productionReceivingReport: state.ProductionReceivingReducer.productionReceivingReport,
    isFetchingOrderCreation: state.OrderCreationReducer.isFetchingOrderCreation,
    orderCreationList: state.OrderCreationReducer.orderCreationList,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceivingReport);
